var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email"},[_c('v-icon',{attrs:{"size":"18px"}},[_vm._v("email")]),_vm._v(_vm._s(_vm.email))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }